import { render } from "./App.vue?vue&type=template&id=6beb9753"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6beb9753&lang=css"
script.render = render

export default script